// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Subtle brand panel */
.GradientCTA_panel__J-dMr {
  width: 100%;
}

.GradientCTA_landing__O9tpT {
  margin-top: var(--space-2);
}
`, "",{"version":3,"sources":["webpack://./src/components/GradientCTA.module.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* Subtle brand panel */\n.panel {\n  width: 100%;\n}\n\n.landing {\n  margin-top: var(--space-2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `GradientCTA_panel__J-dMr`,
	"landing": `GradientCTA_landing__O9tpT`
};
export default ___CSS_LOADER_EXPORT___;
